import { apiClient } from './client';
import type {
  CurrentUserResponse,
  PortalUser,
  UserListResponse,
  CreateUserRequest,
  UpdateUserRequest,
  SystemRolesResponse,
  SystemRole,
  CreateRoleRequest,
  UpdateRoleRequest,
  MenuListResponse,
  PolicyAcceptResponse,
} from './types';

export async function getCurrentUser(): Promise<CurrentUserResponse> {
  return apiClient.get<CurrentUserResponse>('/api/users/me');
}

export async function listUsers(): Promise<UserListResponse> {
  return apiClient.get<UserListResponse>('/api/users');
}

export async function createUser(email: string, roleId: string): Promise<PortalUser> {
  return apiClient.post<PortalUser>('/api/users', { email, roleId } satisfies CreateUserRequest);
}

export async function updateUser(cognitoSub: string, updates: UpdateUserRequest): Promise<PortalUser> {
  return apiClient.put<PortalUser>(`/api/users/${cognitoSub}`, updates);
}

export async function deleteUser(cognitoSub: string): Promise<void> {
  await apiClient.delete(`/api/users/${cognitoSub}`);
}

export async function resendInvitation(cognitoSub: string): Promise<{ resent: boolean; email: string }> {
  return apiClient.post<{ resent: boolean; email: string }>(`/api/users/${cognitoSub}/resend-invitation`, {});
}

export async function listRoles(): Promise<SystemRolesResponse> {
  return apiClient.get<SystemRolesResponse>('/api/system/roles');
}

export async function seedSystem(): Promise<{ message: string }> {
  return apiClient.post<{ message: string }>('/api/system/seed', {});
}

export async function createRole(data: CreateRoleRequest): Promise<SystemRole> {
  return apiClient.post<SystemRole>('/api/system/roles', data);
}

export async function updateRole(roleId: string, data: UpdateRoleRequest): Promise<SystemRole> {
  return apiClient.put<SystemRole>(`/api/system/roles/${roleId}`, data);
}

export async function deleteRole(roleId: string): Promise<void> {
  await apiClient.delete(`/api/system/roles/${roleId}`);
}

export async function listMenus(): Promise<MenuListResponse> {
  return apiClient.get<MenuListResponse>('/api/system/menus');
}

export async function acceptPolicy(): Promise<PolicyAcceptResponse> {
  return apiClient.post<PolicyAcceptResponse>('/api/users/me/accept-policy', {});
}
